/**
 * Category index service — the full A–Z business-category index.
 *
 * API-first: served from the backend `detailed_categories` table via
 * GET /categories/index. The bundled mock data is used ONLY when no API URL is
 * configured (preview mode); with a live API, failures propagate so the page
 * can show a real error + retry state.
 */
import { apiGet, isApiConfigured } from "./http";
import { categoryIndexPartA } from "@/mocks/categoryIndexPartA";
import { categoryIndexPartB } from "@/mocks/categoryIndexPartB";
import type { CategoryLetterGroup } from "@/types/directory";

const demoGroups = (): CategoryLetterGroup[] => [...categoryIndexPartA, ...categoryIndexPartB];

export async function getCategoryIndex(): Promise<CategoryLetterGroup[]> {
  if (!isApiConfigured()) return demoGroups();
  return apiGet<CategoryLetterGroup[]>("/categories/index");
}